import { Box, Button, Card, Stack, Typography } from '@mui/material'

import { useEffect, useState } from 'react'
import WTypography from 'Components/whiteTypography'
import { Bar } from 'react-chartjs-2'
import { faInfo } from '@fortawesome/free-solid-svg-icons/faInfo'

import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest'
import ParmetreSimulationForm from './ParmetreSimulationForm'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)
function MaSimulation({ oldData, updateReports }) {
  const { t, i18n } = useTranslation('layout') // LAP-733 (GE022)
  const [ParmSimulationOpen, setParmSimulationOpen] = useState(false)
  const formatCurrency = (value) =>
    new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR',
      maximumFractionDigits: 0,
    }).format(Number(value || 0))

  const optionsbar = {
    indexAxis: 'x',
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      datalabels: {
        display: false,
      },
      legend: {
        position: 'bottom',
        labels: {
          boxWidth: 10,
          color: 'rgba(255,255,255,0.72)',
          usePointStyle: true,
        },
      },
      tooltip: {
        backgroundColor: '#ffffff',
        titleColor: '#10233f',
        bodyColor: '#10233f',
        borderColor: 'rgba(20, 104, 183, 0.2)',
        borderWidth: 1,
        callbacks: {
          label: (context) => `${context.dataset.label}: ${formatCurrency(context.raw)}`,
          title: (items) => `${t('monPatrimoine.yearTooltip')} ${items?.[0]?.label || ''}`,
        },
      },
    },
    scales: {
      x: {
        stacked: true,
        grid: { color: 'rgba(255,255,255,0.06)' },
        ticks: { color: 'rgba(255,255,255,0.82)', maxRotation: 0 },
      },
      y: {
        stacked: true,
        grid: { color: 'rgba(255,255,255,0.08)' },
        ticks: {
          color: 'rgba(255,255,255,0.82)',
          callback: (value) => formatCurrency(value).replace('€', '').trim(),
        },
      },
    },
  }
  const chartColors = {
    Cash: '#d8e8f6',
    Fondsendevise: '#5aa1d8',
    Alternatifs: '#7cc6b2',
    Immobilier: '#2f8ee8',
    Actions: '#f2b84b',
    Matériel: '#a987ff',
    Dettes: '#ef6b6b',
  }
  const [data, setRevData] = useState({
    labels: [
      '1',
      '2',
      '3',
      '4',
      '5',
      '6',
      '7',
      '8',
      '9',
      '10',
      '11',
      '12',
      '13',
      '14',
      '15',
      '16',
      '17',
      '18',
      '19',
      '20',
    ],
    datasets: [
      // LAP-733 (GE022) — labels translated, then re-set on locale switch via useEffect deps
      {
        label: t('monPatrimoine.cashLabel'),
        data: oldData?.Assets?.Cash?.year,
        backgroundColor: chartColors.Cash,
        borderColor: chartColors.Cash,
        borderRadius: 4,
        barThickness: 12,
      },
      {
        label: t('monPatrimoine.fundInCurrency'),
        data: oldData?.Assets?.Fondsendevise?.year,
        backgroundColor: chartColors.Fondsendevise,
        borderColor: chartColors.Fondsendevise,
        borderRadius: 4,
        barThickness: 12,
      },
      {
        label: t('monPatrimoine.alternative'),
        data: oldData?.Assets?.Alternatifs?.year,
        backgroundColor: chartColors.Alternatifs,
        borderColor: chartColors.Alternatifs,
        borderRadius: 4,
        barThickness: 12,
      },
      {
        label: t('monPatrimoine.realEstate'),
        data: oldData?.Assets?.Immobilier?.year,
        backgroundColor: chartColors.Immobilier,
        borderColor: chartColors.Immobilier,
        borderRadius: 4,
        barThickness: 12,
      },
      {
        label: t('monPatrimoine.shares'),
        data: oldData?.Assets?.Actions?.year,
        backgroundColor: chartColors.Actions,
        borderColor: chartColors.Actions,
        borderRadius: 4,
        barThickness: 12,
      },
      {
        label: t('monPatrimoine.material'),
        data: oldData?.Assets?.Matériel?.year,
        backgroundColor: chartColors.Matériel,
        borderColor: chartColors.Matériel,
        borderRadius: 4,
        barThickness: 12,
      },
    ],
  })
  useEffect(() => {
    let data_set = []
    if (oldData?.Assets?.Cash) {
      data_set.push({
        label: t('monPatrimoine.cashLabel'), // LAP-733 (GE022)
        data: oldData?.Assets?.Cash?.year,
        backgroundColor: chartColors.Cash,
        borderColor: chartColors.Cash,
        borderRadius: 4,
        barThickness: 12,
      })
    }
    if (oldData?.Assets?.Fondsendevise) {
      data_set.push({
        label: t('monPatrimoine.fundInCurrency'), // LAP-733 (GE022)
        data: oldData?.Assets?.Fondsendevise?.year,
        backgroundColor: chartColors.Fondsendevise,
        borderColor: chartColors.Fondsendevise,
        borderRadius: 4,
        barThickness: 12,
      })
    }
    if (oldData?.Assets?.Alternatifs) {
      data_set.push({
        label: t('monPatrimoine.alternative'), // LAP-733 (GE022)
        data: oldData?.Assets?.Alternatifs?.year,
        backgroundColor: chartColors.Alternatifs,
        borderColor: chartColors.Alternatifs,
        borderRadius: 4,
        barThickness: 12,
      })
    }
    if (oldData?.Assets?.Immobilier) {
      data_set.push({
        label: t('monPatrimoine.realEstate'), // LAP-733 (GE022)
        data: oldData?.Assets?.Immobilier?.year,
        backgroundColor: chartColors.Immobilier,
        borderColor: chartColors.Immobilier,
        borderRadius: 4,
        barThickness: 12,
      })
    }
    if (oldData?.Assets?.Actions) {
      data_set.push({
        label: t('monPatrimoine.shares'), // LAP-733 (GE022)
        data: oldData?.Assets?.Actions?.year,
        backgroundColor: chartColors.Actions,
        borderColor: chartColors.Actions,
        borderRadius: 4,
        barThickness: 12,
      })
    }
    if (oldData?.Assets?.Matériel) {
      data_set.push({
        label: t('monPatrimoine.material'), // LAP-733 (GE022)
        data: oldData?.Assets?.Matériel?.year,
        backgroundColor: chartColors.Matériel,
        borderColor: chartColors.Matériel,
        borderRadius: 4,
        barThickness: 12,
      })
    }
    if (oldData?.Assets?.Dettes) {
      data_set.push({
        label: t('monPatrimoine.debts'), // LAP-733 (GE022)
        data: oldData?.Assets?.Dettes?.year,
        backgroundColor: chartColors.Dettes,
        borderColor: chartColors.Dettes,
        borderRadius: 4,
        barThickness: 12,
      })
    }

    setRevData({
      labels: Array.from({ length: 20 }, (_, i) => `${i + 1}`),
      datasets: data_set,
    })
    // LAP-733 (GE022) — refresh dataset labels on locale switch
  }, [oldData, i18n.language])
  const VerticalBarChart = () => (
    <>
      <Bar data={data} options={optionsbar} />
    </>
  )
  return (
    <>
      {ParmSimulationOpen && (
        <ParmetreSimulationForm
          updateReports={updateReports}
          setParmSimulationOpen={setParmSimulationOpen}
        />
      )}
      <Card className="dashboard_card__root1">
        <Box className="dashboard_card__header1">
          <WTypography component={'span'} variant="h6">
            {t('monPatrimoine.mySimulation')}
          </WTypography>
          <Button
            className="no-drag"
            onClick={() => setParmSimulationOpen(true)}
            startIcon={<SettingsSuggestIcon icon={faInfo} />}
            sx={{
              mr: 1,
              minWidth: '23px',
              minHeight: '21px',

              color: 'white',

              borderRadius: '50%',
              '& .MuiButton-startIcon': { margin: 0, '& svg': { fontSize: '26px' } },
              '&:hover': { backgroundColor: 'unset !important' },
            }}
          ></Button>
        </Box>
        <Box px={2} className="no-drag">
          <Typography sx={{ color: 'rgba(255,255,255,0.68)', fontSize: 13, fontWeight: 700, lineHeight: 1.35 }}>
            {t('monPatrimoine.simulation20YearsNote')}
          </Typography>
          <Stack direction="row" gap={1} flexWrap="wrap" sx={{ mt: 1.5 }}>
            <Box sx={{ p: 1, borderRadius: 2, bgcolor: 'rgba(255,255,255,0.08)', minWidth: 112 }}>
              <Typography sx={{ color: 'rgba(255,255,255,0.58)', fontSize: 12 }}>{t('monPatrimoine.today')}</Typography>
              <Typography sx={{ color: '#fff', fontWeight: 850, fontSize: 18 }}>{formatCurrency(oldData?.meta?.initial_total)}</Typography>
            </Box>
            <Box sx={{ p: 1, borderRadius: 2, bgcolor: 'rgba(47,142,232,0.18)', minWidth: 112 }}>
              <Typography sx={{ color: 'rgba(255,255,255,0.58)', fontSize: 12 }}>{t('monPatrimoine.in20Years')}</Typography>
              <Typography sx={{ color: '#fff', fontWeight: 850, fontSize: 18 }}>{formatCurrency(oldData?.meta?.final_total)}</Typography>
            </Box>
            <Box sx={{ p: 1, borderRadius: 2, bgcolor: 'rgba(124,198,178,0.18)', minWidth: 112 }}>
              <Typography sx={{ color: 'rgba(255,255,255,0.58)', fontSize: 12 }}>{t('monPatrimoine.growth')}</Typography>
              <Typography sx={{ color: '#fff', fontWeight: 850, fontSize: 18 }}>{formatCurrency(oldData?.meta?.gain)}</Typography>
            </Box>
          </Stack>
        </Box>

        <Box minWidth={3} mt={1.5} mb={1} height={230} px={2} className="no-drag">
          <VerticalBarChart />
        </Box>
      </Card>
    </>
  )
}

export default MaSimulation
